import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { Post } from "../../models/post.model";

import { PostProvider } from "../../providers/post/post";
import { LanguageProvider } from '../../providers/language/language';

import { PostDetailPage } from "../post-detail/post-detail";
import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-posts',
  templateUrl: 'posts.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class PostsPage {

  posts: Post[];
  loading: boolean;

  dateLocale: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public languageProvider: LanguageProvider, public postProvider: PostProvider) {
    this.dateLocale = this.languageProvider.getByLocale(this.translate.currentLang).code;
  }

  getPosts() {
    this.loading = true;
    this.postProvider.getAll()
      .subscribe(
        posts => this.posts = posts,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  reloadPosts(refresher) {
    this.postProvider.getAll()
      .subscribe(
        posts => this.posts = posts,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          refresher.complete();
        },
        () => {
          refresher.complete();
        }
      );
  }

  openDetail(post) {
    this.navCtrl.push(PostDetailPage, {
      id: post.id
    });
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getPosts();
  }

}



// WEBPACK FOOTER //
// ./src/pages/posts/posts.ts